import AppToast from "../ui/AppToast";

const ValidateMinTel = (telephoneNumber, cellPhoneNumber) => {

    let success = true;

    if (String(telephoneNumber).trim() === '' && String(cellPhoneNumber).trim() === '') {
        AppToast('Por favor ingrese al menos un número de teléfono o celular', false);
        success = false;
    }

    return success;

}

export default ValidateMinTel